import { render } from "./editMaterialNameAndGramsModal.vue?vue&type=template&id=d7274506&ts=true"
import script from "./editMaterialNameAndGramsModal.vue?vue&type=script&lang=ts"
export * from "./editMaterialNameAndGramsModal.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__